<div *ngIf="reportGenerationForm != null" [formGroup]="reportGenerationForm">
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="timeOffCodes">Select Time-Off codes to be included</label>
        <lib-multiselect
          id="timeOffCodes"
          [options]="timeOffCodes"
          formControlName="timeOffCodes"></lib-multiselect>
        <small
          class="form-text error-text"
          *ngIf="reportGenerationForm.get('timeOffCodes').errors?.mustSelectCode"
          >*You must select at least one code.</small
        >
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="firstSortBy">First Sort By:</label>
        <select formControlName="firstSortBy" id="firstSortBy" class="form-control">
          <option *ngFor="let opt of sortOptions" [value]="opt.FirstSort">
            {{ opt.FirstSort }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="secondSortBy">Second Sort By:</label>
        <select formControlName="secondSortBy" id="secondSortBy" class="form-control">
          <option *ngFor="let opt of secondSortOptions" [value]="opt">{{ opt }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        formControlName="excludeTerminatedEmployees"
        label="Do not include terminated employees"></lib-checkbox>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-checkbox
        formControlName="includeNonActiveParticipatingEmployees"
        label="Include a row for non-participating active employees"></lib-checkbox>
    </div>
  </div>
  <lib-report-buttons
    [disabled]="reportGenerationForm.invalid"
    (generateReport)="generateReport()"
    (downloadReport)="downloadReport($event)"></lib-report-buttons>
</div>
